<script lang="ts" setup></script>
<template>
  <svg
    width="32"
    height="38"
    viewBox="0 0 32 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Icon"
      d="M14.6913 36.5512C15.1064 36.7862 15.3139 36.9036 15.6068 36.9645C15.8342 37.0118 16.1658 37.0118 16.3932 36.9645C16.6861 36.9036 16.8936 36.7862 17.3087 36.5512C20.9613 34.4842 31 27.9913 31 19.064V10.3659C31 8.9118 31 8.18474 30.7548 7.55976C30.5382 7.00765 30.1863 6.51501 29.7294 6.12443C29.2122 5.68231 28.5104 5.42702 27.1067 4.91644L17.0534 1.25949C16.6636 1.1177 16.4687 1.0468 16.2682 1.0187C16.0903 0.993768 15.9097 0.993768 15.7318 1.0187C15.5313 1.0468 15.3364 1.1177 14.9466 1.25949L4.89326 4.91644C3.48962 5.42702 2.7878 5.68231 2.27061 6.12443C1.81372 6.51501 1.46176 7.00765 1.24518 7.55976C1 8.18474 1 8.9118 1 10.3659V19.064C1 27.9913 11.0387 34.4842 14.6913 36.5512Z"
      stroke="var(--border)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
